// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"bfbc9a8d97553fe6","729":"fb917041f7d62515","2013":"8cb35cbb04bc04c2","3807":"7e58bd0d9b37200c"}[chunkId] + ".js";
};